export default "__VITE_ASSET__480fe43a__"